import React, { Component } from "react";
import "../../styles/legal_terms/legal_terms.css";

class PrivacyPolicy extends Component {
  render() {
    return (
        <div className="legal-terms-container">
            <article>
                <h1>Política de privacidad</h1>
                <p>
                    En NOI Donostia, estamos comprometidos con la protección de su privacidad y la seguridad de sus datos personales. Esta política de privacidad describe cómo recopilamos, utilizamos y protegemos la información que usted nos proporciona cuando visita nuestro sitio web.
                    Recopilamos información personal, como su nombre, dirección de correo electrónico y número de teléfono, cuando usted nos la proporciona voluntariamente al completar formularios de contacto o al realizar una reserva a través de nuestro sitio web.
                    Utilizamos la información que recopilamos para comunicarnos con usted, procesar sus solicitudes y mejorar nuestros servicios. No compartimos su información personal con terceros sin su consentimiento, excepto cuando sea necesario para cumplir con requisitos legales o proteger nuestros derechos.
                    Utilizamos medidas de seguridad técnicas y organizativas para proteger su información personal contra el acceso no autorizado, la divulgación, la alteración o la destrucción.
                    Al utilizar nuestro sitio web, usted acepta esta política de privacidad. Si tiene alguna pregunta o inquietud sobre cómo manejamos sus datos personales, por favor contáctenos a través de la información proporcionada en la sección de contacto.
                    <br/>
                    Gracias por confiar en NOI Donostia.
                </p>
            </article>
        </div>
      );
  }
}

export default PrivacyPolicy;